import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './Pages/home/home.component';
import { ComicComponent } from './Pages/comic/comic.component';
import { CharactersComponent} from './Pages/characters/characters.component';
import { AboutComponent } from './Pages/about/about.component';
import { MerchandiseComponent } from './Pages/merchandise/merchandise.component';


const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'comic', component: ComicComponent },
  { path: 'comic/:comicid', component: ComicComponent },
  { path: 'comic/:comicid/page/:pageid', component: ComicComponent },
  { path: 'characters', component: CharactersComponent },
  { path: 'merchandise', component: MerchandiseComponent },
  { path: 'about', component: AboutComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
